import { ApolloClient, InMemoryCache } from '@apollo/client';
import MarketHelper from 'helpers/MarketHelper';
import { getReferrerMarket } from './getReferrerMarket';

export const cache = new InMemoryCache();

export const apolloClient = () => {
    const market = getReferrerMarket(window.location.href);

    return new ApolloClient({
        uri: `${MarketHelper.getBackendDomain(market)}/graphql`,
        cache,
        credentials: 'include',
        defaultOptions: { query: { errorPolicy: 'all', fetchPolicy: 'no-cache' } },
    });
};
